import React from 'react';
import Image from 'next/image';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ConsumerIntentModule from '../Cim/CIMContainer';
import { default as SuperHeroComponent } from './SuperHero';
import NativeAd from '@kbbsdk/global-sdk/ads/NativeAd';
import { breakpoints, colors } from '@argo/principles';
import { SUPER_HERO_HEIGHT, SUPER_HERO_MAX_HEIGHT } from '../constants';
import PropTypes from 'prop-types';
import superHeroData from './SuperHeroData';

// #region SuperHeroStyles
const SuperHeroContainer = styled.div`
  position: relative;
  max-width: 100vw;
  width: 100%;
  height: ${SUPER_HERO_HEIGHT.BASE}px;
  @media (max-width: ${breakpoints.lg - 1}px) {
    height: 626px;
  }
  @media (max-width: ${breakpoints.md - 1}px) {
    height: ${SUPER_HERO_HEIGHT.MD}px;
  }
  @media (min-width: ${breakpoints.lg}px) {
    height: 505px;
  }
  @media (min-width: ${breakpoints.sm - 1}px) and (max-width: 384px) {
    height: 600px;
  }
  @media (min-width: 385px) and (max-width: ${breakpoints.md - 1}px) {
    height: 510px;
  }
`;

const superheroContainerCss = css`
  max-height: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    height: ${SUPER_HERO_MAX_HEIGHT}px;
  }
`;
// #endregion SuperHeroStyles

// Generated by GitHub Copilot
function SuperHero({ useXandr = false, isMobileDevice = false }) {
  const { impressionUrls } = superHeroData || {};
  return (
    <SuperHeroContainer id="superheroSection">
      <ConsumerIntentModule data-lean-auto="green-monster-0" />
      {!useXandr ? (
        <NativeAd id="kbbAdsSuperHero" postMessageName="kbbAdsSuperHero" nativeContentProps={{ css: superheroContainerCss }}>
          {({ loading, hasData, data: adData }) => {
            let destinationUrl = '';
            let secondaryLinkUrl = '';
            let thirdPartyPixel = '';
            let destinationUrlIsExternal = false;

            if (!loading && hasData && adData.options) {
              const { destinationUrlOption = '', secondaryLinkUrlOption = '', destinationUrlIsExternalOption = false } = adData.options;
              destinationUrl = destinationUrlOption;
              secondaryLinkUrl = secondaryLinkUrlOption;
              thirdPartyPixel = adData.options['3rd_party_click_tracker'] || '';
              destinationUrlIsExternal = destinationUrlIsExternalOption;
            }

            const gamComponentData = {
              ...superHeroData,
              destinationUrl,
              secondaryLinkUrl,
              thirdPartyPixel,
              destinationUrlIsExternal,
            };

            return <SuperHeroComponent superHeroData={gamComponentData} isMobileDevice={isMobileDevice} />;
          }}
        </NativeAd>
      ) : (
        <>
          {impressionUrls?.map((impression, index) => (
            <Image
              key={impression}
              src={impression}
              id={`xandrImpressionSuperHero-${index}`}
              alt="xandr-impression-pixel"
              width="1"
              height="1"
              style={{ visibility: 'hidden', position: 'absolute' }}
            />
          ))}
          <SuperHeroComponent
            data-automation="xandr-superhero"
            superHeroData={{
              ...superHeroData, backgroundColor: colors.primary.black, headerColor: colors.primary.white, ctaButtonColor: '#e85b00',
            }}
            isMobileDevice={isMobileDevice}
            useXandr={useXandr}
          />
        </>
      )}
    </SuperHeroContainer>
  );
}

SuperHero.propTypes = {
  // superHeroData: PropTypes.object(),
  useXandr: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
};

SuperHero.defaultProps = {
  useXandr: false,
  isMobileDevice: false,
};

export default SuperHero;
